import { Provider } from './Context.js';
import { Calendar } from './components/Calendar.js';
import { jsx } from 'react/jsx-runtime';

function CalendarWithContext(props) {
  var onChange = props.onChange,
    value = props.value,
    locale = props.locale,
    timeZone = props.timeZone,
    weekStartsOn = props.weekStartsOn,
    min = props.min,
    max = props.max,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onKeyDown = props.onKeyDown;
  return /*#__PURE__*/jsx(Provider, {
    onChange: onChange,
    value: value,
    locale: locale,
    timeZone: timeZone,
    weekStartsOn: weekStartsOn,
    min: min,
    max: max,
    onFocus: onFocus,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    children: /*#__PURE__*/jsx(Calendar, {})
  });
}

export { CalendarWithContext as default };
